import React, { useState } from 'react';

const ViewAllEmployees = ({ employees }) => {
  const [search, setSearch] = useState('');

  const handleTextSearch = (e) => {
    e.preventDefault();
    setSearch(e.target.value);
  };

  const messageLink = (e, id) => {
    e.preventDefault();
    window.location.href = `/conversations/new?participant_id=${id}`;
  };

  const nameIncludesSearch = (name) => name.toLowerCase().includes(search);

  const renderEmployee = (employee) => (
    <div className="card-container" key={employee.id}>
      <div className="voray-entity-card card-circle">
        <div className="image">
          <img src={employee.headshot} alt={employee.displayName} />
        </div>
        <div className="fw">
          <div className="left">
            <a href={`${location.origin}/users/${employee.slug}`}>
              <span className="text-black t3 w3">{employee.displayName}</span>
            </a>
            <span className="block text-blue1">{employee.title}</span>
          </div>
          <button
            onClick={(e) => messageLink(e, employee.id)}
            className="btn-main right mt-15"
          >
            Message
          </button>
        </div>
      </div>
    </div>
  );

  const renderEmployeesWithSearch = employees?.map((employee) =>
    nameIncludesSearch(employee.displayName) ? renderEmployee(employee) : null
  );

  return (
    <div>
      <input
        className="form-control p-3 rounded-3 w-100"
        type="search"
        placeholder={'Search Employees'}
        aria-label="Search"
        onChange={handleTextSearch}
        value={search}
      />
      <div className="view-all-entities">{renderEmployeesWithSearch}</div>
    </div>
  );
};

export default ViewAllEmployees;
